export default __webpack_public_path__ + "static/media/client_img2.91a4582b.png";